import { apiClient } from '@/services/ApiClient.js'

export class FindeksRequestService {
  getFindeksRequests(application, query) {
    return apiClient
      .get('applications/' + application + '/findeks-requests', {
        params: query
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }
}
